import PLANS_PRICING, {
  ENTERPRISE_TARIFF_NAME,
  FREE_TARIFF_NAME,
  PAYMENT_METHOD_CAPITALIST_NAME,
  PAYMENT_METHOD_CARD_NAME,
  PAYMENT_METHOD_CRYPTO_NAME,
  PAYMENT_METHOD_UNLIMINT_NAME, PAYMENT_METHOD_WALLET_NAME,
  TRIAL_PERIOD_NAME
} from '../constants/plans'
import moment from 'moment';

export default {
  methods: {
    simpleEstimateCalculation() {
      if (!this.selectedPlan.plan) return;
      const plan = this.selectedPlan.plan;
      const prolongMonths = parseInt(this.selectedPlan.prolongMonths || 1, 10);
      const profilesCount = parseInt(this.selectedPlan.profilesCount || 0, 10)
      const additionalUsers = parseInt(this.selectedPlan.additionalUsers || 0, 10);
      const additionalProfiles = parseInt(this.selectedPlan.additionalProfiles || 0, 10);
      const discount = parseInt(this.selectedPlan.discount || 0, 10);
      const paymentMethod = this.selectedPlan.paymentMethod;

      let additionalUsersCost = 0;
      let additionalProfileCost = 0;

      const planPrice = PLANS_PRICING[plan].price

      // [for free] additional ten profiles
      if (['free'].indexOf(plan) > -1) {
        additionalProfileCost = Math.ceil((profilesCount -10) / 10) * PLANS_PRICING[plan].additionalTenProfiles
      }

      // [for enterprice] additional thousand profiles
      if (['enterprise'].indexOf(plan) > -1) {
        additionalProfileCost = Math.ceil((profilesCount - 1000) / 1000) * PLANS_PRICING[plan].additionalThousandProfiles
      }

      // additional users
      if (['base', 'team', 'enterprise'].indexOf(plan) > -1) {
        // calculate
        additionalUsersCost = additionalUsers * PLANS_PRICING[plan].additionalUser
      }

      if(this.profile.subscription.plan === 'trial' && plan === 'free') {
        additionalProfileCost =  Math.ceil(additionalProfiles / 10) * PLANS_PRICING[plan].additionalTenProfiles
      }
      let total = (planPrice + additionalUsersCost + additionalProfileCost) * prolongMonths

      if (discount > 0) {
        total = total - total * (discount/100)
      }
      switch (paymentMethod) {
      case 'card':
        total = total + total * 0.03
        break;
      case 'unlimint':
        total = (total>0) ? total + total * 0.029 + 0.30 : 0
        break;
      case 'crypto':
        total = total + total * 0.05
        break;
      case 'capitalist':
        total = total + total * 0.045
        break;
      case 'wallet':
        total = total + total * 0.045
        break;
      case 'usdt':
        total = total + total * 0.00
        break;
      }
      this.estimate = total
    },

    getDaysUntilExpiration(expirationDate) {
      const currentDate = moment.utc().valueOf();
      const timeLeft = new Date(expirationDate).getTime() - currentDate;
      const millisecondsPerDay = 1000 * 60 * 60 * 24;

      return Math.round(timeLeft / millisecondsPerDay);
    },
  }
}
